import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { Button, EditIcon, Text } from '@mercai/clever'
import { CustomAccordion } from '@/components'

import { checkIfLogisticPreferencesIsComplete } from '../../general.constants'

import { ProfileLogisticPreferencesProps } from './logistic-preferences.type'

import styles from './logistic-preferences.module.css'

export const ProfileLogisticPreferences = ({
  profile,
  onClickEdit,
}: ProfileLogisticPreferencesProps) => {
  const { t: tEnums } = useTranslation('enums')
  const { t } = useTranslation('screenProfileShow')

  const [activeItems, setActiveItems] = useState(['consumption'])

  const isCompleted = checkIfLogisticPreferencesIsComplete(profile)

  return (
    <div className={styles.core}>
      <CustomAccordion
        activeItems={activeItems}
        setActiveItems={setActiveItems}
        id="consumption"
        title={`7. ${t('generalViewGeneralInformationLogisticPreferencesTitle')}`}
        isComplete={isCompleted}
      >
        <div className={styles['info-block']}>
          <div className={styles['info-row']}>
            <div className={styles['info-row-content']}>
              <Text className={styles['info-item']}>
                <strong>{t('generalViewLogisticTimeLabel')}:</strong>{' '}
                {profile?.selectedDeliveryPeriods?.length
                  ? profile.selectedDeliveryPeriods.reduce((acc, curr) => {
                      return (
                        acc +
                        `${acc ? ', ' : ''}` +
                        tEnums(`profile_selected_delivery_period_${curr}`)
                      )
                    }, '')
                  : '-'}
              </Text>

              <Text className={styles['info-item']}>
                <strong>{t('generalViewLogisticDaysLabel')}:</strong>{' '}
                {profile?.selectedDeliveryDays?.length
                  ? profile.selectedDeliveryDays.reduce((acc, curr) => {
                      return (
                        acc +
                        `${acc ? ', ' : ''}` +
                        tEnums(`profile_selected_delivery_days_${curr}`)
                      )
                    }, '')
                  : '-'}
              </Text>
            </div>

            <Button
              variant="secondary"
              className={styles.edit}
              size="small"
              onClick={onClickEdit}
            >
              <EditIcon />
            </Button>
          </div>
        </div>
      </CustomAccordion>
    </div>
  )
}
